"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.MarkdownImage = styled_components_1.default.img `
  grid-column: first / span 12;
  max-width: 100%;
  height: auto;
`;
//# sourceMappingURL=markdown-image.js.map